<div class="tc-spinner __default __dark">
  <div class="bounce1" />
  <div class="bounce2" />
  <div class="bounce3" />
</div>
